export default "__VITE_ASSET__e9890b55__"